import React, { useState, useEffect } from 'react'
import './Home.css'
import Footer from '../UIElements/Footer'
import HomeHomeNavigation from './HomeHomeNavigation'
import LoadingSpinner from '../UIElements/LoadingSpinner'
import ErrorModal from '../UIElements/ErrorModal'
import YouTube from 'react-youtube'
import Carousel from 'react-bootstrap/Carousel'
/* import cadetBrookline from '../images/CadetBrookline.jpg'
import penguinBrookline from '../images/PenguinBrookline.jpg'
import snipersMidwest from '../images/SnipersMidwest.jpg'
import beaverBills from '../images/BeaverABills.jpg'
import penguinVenom from '../images/PenguinAVenom.jpg'
import beaverAVenom from '../images/BeaverAVenom.jpg'
import cadetPH from '../images/CadetAPennHills.jpg'
import beaverAPH from '../images/BeaverAPennHills.jpg'
import penguinPH from '../images/PenguinAPennHills.jpg'
import chipmunkPH from '../images/ChipmunkPennHills.jpg'
import cadetRiverview from '../images/CadetARiverview.jpg'
import penguinRiverview from '../images/PenguinARiverview.jpg'
import beaverACranberry from '../images/BeaverACranberry.jpg'
import penguinCranberry from '../images/PenguinACranberry.jpg'
import freshmenCranberry from '../images/FreshmenACranberry.jpg'
import chipmunkCranberry from '../images/ChipmunkCranberry.jpg'
import chipmunkMckeesport from '../images/ChipmunkMcKeesport.jpg' */
var getYouTubeID = require('get-youtube-id')

const Home = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [ids, setIds] = useState([])
	const [videoTitles, setVideoTitles] = useState([])
	const [videoCaptions, setVideoCaptions] = useState([])
	const [loadedVideos, setLoadedVideos] = useState([])
	const [loadedNews, setLoadedNews] = useState([])
	//console.log('auth: ' + JSON.stringify(auth))

	//Get all videos designated for the Home Page
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/homePageVideos'
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedVideos(responseData.allHomePageVideos)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			//
			//
			setIsLoading(false)
		}

		sendRequest()
	}, [])

	let arrayOfTitles, arrayOfIds, arrayOfCaptions
	arrayOfTitles = []
	arrayOfIds = []
	arrayOfCaptions = []
	if (loadedVideos && !isLoading && ids.length === 0) {
		loadedVideos.forEach((video) => {
			arrayOfTitles.push(video.videoTitle)
			arrayOfIds.push(getYouTubeID(video.videoURL))
			arrayOfCaptions.push(video.videoCaption)
		})
	}

	if (arrayOfTitles.length > 0) {
		setVideoTitles(arrayOfTitles)
	}
	if (arrayOfIds.length > 0) {
		setIds(arrayOfIds)
	}
	if (arrayOfCaptions.length > 0) {
		setVideoCaptions(arrayOfCaptions)
	}
	//
	//
	//
	//
	//
	//
	//
	//Get all News
	useEffect(() => {
		const sendRequest2 = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/news'
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedNews(responseData.allNews)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			//
			//
			setIsLoading(false)
		}

		sendRequest2()
	}, [])
	//
	//
	//
	//
	//
	//
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	return (
		<React.Fragment>
			{/* <ErrorModal error={error} onClear={errorHandler} />
			{isLoading && <LoadingSpinner asOverlay />}
			{!isLoading && (
				<div>
					<header className='homeHeader'>
						<HomeHomeNavigation />
						<div className='text-light text-md-right text-center banner headingWriting'>
							<h1
								className='display-4 lead headingText'
								style={{
									fontWeight: '600',
									color: 'white',
									textShadow: '2px 2px 2px #ee2e30',
								}}
							>
								Penn Hills Arsenal
							</h1>
							<div className='underline-white mb-4'></div>
							<h1
								className='display-4 lead subheading'
								style={{
									marginBottom: '1rem',
									fontWeight: '600',
									color: 'white',
									textShadow: '2px 2px 2px #ee2e30',
								}}
							>
								Est. 1992
							</h1>
						</div>
					</header>
					<div className='section pt-5'>
						<div className=''>
							<div className='row'>
								<div className='col text-center'>
									<h1 className='newsAndUpdates display-2'>News and Updates</h1>
								</div>
							</div>
							<div className='row'>
								<div className='col-lg-3 col-sm-6'></div>
								{!isLoading &&
									loadedNews &&
									loadedNews.map((news, key) => {
										return (
											<div>
												<h1 style={{ color: 'red' }}>{news.newsHeading}</h1>

												<p
													className='caption'
													style={{
														textAlign: 'center',
														color: 'black',
													}}
												>
													{news.newsSubheading}
												</p>
												<p
													className='caption'
													style={{
														textAlign: 'center',
														color: 'black',
													}}
												>
													{news.newsDate}
												</p>
												<p
													className='content'
													style={{
														textAlign: 'center',
														color: 'black',
														marginBottom: '3rem',
														whiteSpace: 'pre-wrap',
													}}
												>
													{news.newsContent}
												</p>
											</div>
										)
									})}
								<div className='col-lg-3 col-sm-6'></div>
							</div>
						</div>
					</div>
					<div className='section pt-5 customers' id='testimonials'>
						<div className=''>
							<div className='row'>
								<div className='col text-center mb-3'>
									<h1
										className='display-4 lead headingText'
										style={{
											fontWeight: '600',
											color: 'white',
											textShadow: '2px 2px 2px #ee2e30',
										}}
									>
										2024 Tournament Champions
									</h1>
								</div>
								<div className='section'>
									<div className=''>
										<Carousel>
											<Carousel.Item interval={7000}>
												<img
													className='d-block w-75'
													src={penguinBrookline}
													alt='Image One'
												/>
											</Carousel.Item>
											<Carousel.Item interval={7000}>
												<img
													className='d-block w-75'
													src={cadetBrookline}
													alt='Image Two'
												/>
											</Carousel.Item>
											<Carousel.Item interval={7000}>
												<img
													className='d-block w-75'
													src={snipersMidwest}
													alt='Image Three'
												/>
											</Carousel.Item>
											<Carousel.Item interval={7000}>
												<img
													className='d-block w-75'
													src={beaverBills}
													alt='Image Four'
												/>
											</Carousel.Item>
											<Carousel.Item interval={7000}>
												<img
													className='d-block w-75'
													src={penguinVenom}
													alt='Image Five'
												/>
											</Carousel.Item>
											<Carousel.Item interval={7000}>
												<img
													className='d-block w-75'
													src={beaverAVenom}
													alt='Image Six'
												/>
											</Carousel.Item>
											<Carousel.Item interval={7000}>
												<img
													className='d-block w-75'
													src={cadetPH}
													alt='Image Seven'
												/>
											</Carousel.Item>
											<Carousel.Item interval={7000}>
												<img
													className='d-block w-75'
													src={beaverAPH}
													alt='Image Eight'
												/>
											</Carousel.Item>
											<Carousel.Item interval={7000}>
												<img
													className='d-block w-75'
													src={penguinPH}
													alt='Image Nine'
												/>
											</Carousel.Item>
											<Carousel.Item interval={7000}>
												<img
													className='d-block w-75'
													src={chipmunkPH}
													alt='Image Ten'
												/>
											</Carousel.Item>
											<Carousel.Item interval={7000}>
												<img
													className='d-block w-75'
													src={cadetRiverview}
													alt='Image Eleven'
												/>
											</Carousel.Item>
											<Carousel.Item interval={7000}>
												<img
													className='d-block w-75'
													src={penguinRiverview}
													alt='Image Twelve'
												/>
											</Carousel.Item>
											<Carousel.Item interval={7000}>
												<img
													className='d-block w-75'
													src={beaverACranberry}
													alt='Image Thirteen'
												/>
											</Carousel.Item>
											<Carousel.Item interval={7000}>
												<img
													className='d-block w-75'
													src={penguinCranberry}
													alt='Image Fourteen'
												/>
											</Carousel.Item>
											<Carousel.Item interval={7000}>
												<img
													className='d-block w-75'
													src={freshmenCranberry}
													alt='Image Fifteen'
												/>
											</Carousel.Item>
											<Carousel.Item interval={7000}>
												<img
													className='d-block w-75'
													src={chipmunkCranberry}
													alt='Image Sixteen'
												/>
											</Carousel.Item>
											<Carousel.Item interval={7000}>
												<img
													className='d-block w-75'
													src={chipmunkMckeesport}
													alt='Image Seventeen'
												/>
											</Carousel.Item>
										</Carousel>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className='section pt-5 videos'>
						<div className=''>
							<div className='row'>
								<div className='col text-center mb-0'>
									<h1 className='watch display-2'>Watch!</h1>
								</div>
							</div>
							<div className='row'>
								<div className='col-lg-3 col-sm-3'></div>
								<div className='col-lg-6 col-sm-6'>
									{!isLoading &&
										loadedVideos &&
										loadedVideos.map((video, key) => {
											return (
												<div>
													<h1 style={{ color: 'red' }}>{video.videoTitle}</h1>

													<p
														className='caption'
														style={{
															textAlign: 'center',
															color: 'black',
														}}
													>
														{video.videoCaption}
													</p>
													{
														<YouTube
															style={{ paddingBottom: '3rem' }}
															videoId={ids[key]}
														/>
													}
												</div>
											)
										})}
								</div>
								<div className='col-lg-3 col-sm-3'></div>
							</div>
						</div>
					</div>
					<div className='section p-5 container-gray'></div>
				</div>
			)}
			<Footer /> */}
		</React.Fragment>
	)
}

export default Home
